import { Component } from 'react';
import { Menu, MenuTheme } from 'antd';
import { router, connect } from 'dva';

import CustomScrollbars from '@src/util/CustomScrollbars';
import SidebarLogo from './SidebarLogo';

import Auxiliary from '@src/util/Auxiliary';
import UserProfile from './UserProfile';
import AppsNavigation from './AppsNavigation';
import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE,
} from '../../constants/ThemeSetting';
// import IntlMessages from "../../util/IntlMessages";
import RenderIcon from '@src/packages/pro-icon/RenderIcon';
import { StoreState } from '@src/interfaces';
import { IS_DEBUG } from '@src/constants/constants';

const SubMenu = Menu.SubMenu;
// const MenuItemGroup = Menu.ItemGroup
const { Link } = router;

class SidebarContent extends Component<{
  location?: any;
  themeType: string;
  navStyle: string;
  pathname: string;
  menus: any;
}> {
  getNoHeaderClass = (navStyle: string) => {
    if (
      navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR ||
      navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR
    ) {
      return 'gx-no-header-notifications';
    }
    return '';
  };

  getNavStyleSubMenuClass = (navStyle: string) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
      return 'gx-no-header-submenu-popup';
    }
    return '';
  };

  getStoredLocale = () => {
    try {
      const stored = localStorage.getItem('app_locale');
      if (stored) {
        return JSON.parse(stored);
      }
    } catch (error) {
      console.error('Error reading locale from localStorage:', error);
    }
    return null;
  };

  getLocaleName = (locale: string, item: any) => {
    const translation = item.translations?.find(
      (translation: any) => translation.language === locale
    );
    if (translation) return translation.name;
    return item.name;
  };

  renderMenu = (data = [], level = 0, navStyle: string) => {
    const storedLocale = this.getStoredLocale();
    const locale = storedLocale?.locale || 'vi';
    return (
      <>
        {data.map((item: any) => {
          let result;
          if (item.isParent && item.children && item.children.length) {
            if (level === 0) {
              result = (
                <SubMenu
                  key={item.id}
                  className={this.getNavStyleSubMenuClass(navStyle)}
                  title={
                    <>
                      <RenderIcon icon={item.icon} />{' '}
                      <span>{this.getLocaleName(locale, item)}</span>
                    </>
                  }
                >
                  {this.renderMenu(item.children, 1, navStyle)}
                </SubMenu>
              );
            } else {
              result = (
                <SubMenu
                  key={item.id}
                  className={this.getNavStyleSubMenuClass(navStyle)}
                  title={
                    <>
                      <RenderIcon icon={item.icon} />{' '}
                      <span>{this.getLocaleName(locale, item)}</span>
                    </>
                  }
                >
                  {this.renderMenu(item.children, 2, navStyle)}
                </SubMenu>
              );
            }
          } else {
            if (level === 0) {
              result = (
                <Menu.Item key={item.id}>
                  <Link to={item.url}>
                    <RenderIcon icon={item.icon} />{' '}
                    <span>{this.getLocaleName(locale, item)}</span>
                  </Link>
                </Menu.Item>
              );
            } else {
              result = (
                <Menu.Item key={item.id}>
                  <Link to={item.url}>
                    <RenderIcon icon={item.icon} />{' '}
                    <span>{this.getLocaleName(locale, item)}</span>
                  </Link>
                </Menu.Item>
              );
            }
          }

          return result;
        })}
      </>
    );
  };

  render() {
    const { themeType, navStyle, /* pathname, */ menus } = this.props;
    return (
      <Auxiliary>
        <SidebarLogo />
        <div className='gx-sidebar-content'>
          <div
            className={`gx-sidebar-notifications ${this.getNoHeaderClass(
              navStyle
            )}`}
          >
            <UserProfile />
            <AppsNavigation />
          </div>
          <CustomScrollbars className='gx-layout-sider-scrollbar'>
            <Menu
              theme={
                (themeType === THEME_TYPE_LITE ? 'lite' : 'dark') as MenuTheme
              }
              mode='inline'
              onClick={({ key, keyPath }) => {
                if (IS_DEBUG) {
                  console.info(
                    `🚀 ~ file: SidebarContent.js ~ SidebarContent ~ render ~ key, keyPath`,
                    key,
                    keyPath
                  );
                }
              }}
            >
              {this.renderMenu(menus, 0, navStyle)}
            </Menu>
          </CustomScrollbars>
        </div>
      </Auxiliary>
    );
  }
}

const mapStateToProps = ({ settings, menu, router }: StoreState) => {
  const { menus } = menu;
  const { navStyle, themeType, locale, pathname } = settings;
  const { location } = router;
  return { navStyle, themeType, locale, pathname, menus, location };
};
export default connect(mapStateToProps)(SidebarContent);
